(() => {
  const normalize = value => value.replace(/(?:€[\s\u00a0\u202f]*)(\d+(?:[.,\s\u00a0\u202f]\d{3})*(?:[.,]\d{2})?)|(\d+(?:[.,\s\u00a0\u202f]\d{3})*(?:[.,]\d{2})?)[\s\u00a0\u202f]*€/g, (_, before, after) => (before || after).replace(/([.,])00$/, '') + '€');
  const excluded = node => node.parentElement?.closest('script,style,textarea,input,select,option,[contenteditable="true"],svg');
  function update(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      if (!excluded(root)) { const next = normalize(root.nodeValue); if (next !== root.nodeValue) root.nodeValue = next; }
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches('script,style,textarea,input,select,svg')) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(update);
  }
  const start = () => {
    update(document.body);
    const observer = new MutationObserver(records => {
      observer.disconnect();
      records.forEach(record => record.type === 'characterData' ? update(record.target) : record.addedNodes.forEach(update));
      observer.observe(document.body, {subtree: true, childList: true, characterData: true});
    });
    observer.observe(document.body, {subtree: true, childList: true, characterData: true});
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, {once:true}) : start();
})();